export enum ChallengeWindowSize {
    width250xheight400 = '01',
    width390xheight400 = '02',
    width500xheight600 = '03',
    width600xheight400 = '04',
    fullscreen = '05'
}
